import { useEffect } from "react";
import { Home } from "./home";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Loading } from "@/components/Loading";

export function HomePage() {
  const navigate = useNavigate();
  const hasOfferCookie = !!Cookies.get("offer");

  useEffect(() => {
    if (hasOfferCookie) {
      // Cliente que entrou por link de oferta fica preso a ela: a entrada do
      // fluxo e /personal-data. `replace` para "/" nao ficar no historico —
      // senao o voltar do navegador cai aqui e e redirecionado de novo.
      navigate("/personal-data", { replace: true });
    }
  }, [hasOfferCookie, navigate]);

  // Nao montar a Home enquanto redireciona: o mount dela zera activePages e
  // o formulario, o que derruba o route guard de /personal-data e cria o
  // loop "/" <-> "/personal-data".
  if (hasOfferCookie) {
    return <Loading src="/tim_logo.svg" />;
  }

  return <Home />;
}
